export default __webpack_public_path__ + "static/media/image2.beda7d2b.png";